/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListRemindersQueryResponse,
  ListRemindersQueryParams,
  ListReminders500,
} from '../../types/ListReminders'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listReminders } from '../../clients/listReminders'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listRemindersQueryKey = (params?: ListRemindersQueryParams) =>
  [
    { url: '/api/v1/reminders/reminders/' },
    ...(params ? [params] : []),
  ] as const

export type ListRemindersQueryKey = ReturnType<typeof listRemindersQueryKey>

export function listRemindersQueryOptions(
  params?: ListRemindersQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listRemindersQueryKey(params)
  return queryOptions<
    ListRemindersQueryResponse,
    ResponseErrorConfig<ListReminders500>,
    ListRemindersQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listReminders(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Get paginated list of reminders.
 * Delegates to GetRemindersListUsecase for business logic.
 * @summary List reminders for the current company with filtering and pagination
 * {@link /api/v1/reminders/reminders/}
 */
export function useListReminders<
  TData = ListRemindersQueryResponse,
  TQueryData = ListRemindersQueryResponse,
  TQueryKey extends QueryKey = ListRemindersQueryKey,
>(
  params?: ListRemindersQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListRemindersQueryResponse,
        ResponseErrorConfig<ListReminders500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listRemindersQueryKey(params)

  const query = useQuery(
    {
      ...listRemindersQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<ListReminders500>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
